// Темата на antd за страниците на „Складова база": кехлибареният акцент на
// модула (светъл/тъмен) и закръгляне 8. `controlHeight` — само за работните
// листове, където полетата са по-високи (40).
import type { ReactNode } from "react";
import { ConfigProvider } from "antd";
import { useIsDarkTheme } from "../../../store/hooks";

type Props = {
  controlHeight?: number;
  children: ReactNode;
};

export const InventoryTheme = ({ controlHeight, children }: Props) => {
  const isDark = useIsDarkTheme();
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#D97706",
          colorPrimaryHover: "#B45309",
          controlItemBgActive: isDark ? "#382a12" : "#FFF4E0",
          borderRadius: 8,
          ...(controlHeight ? { controlHeight } : {}),
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default InventoryTheme;
